<div class='wrapperForTest'>
  <img src='assets/calendar/calendar.gif'>
</div>